/**
 * @module events/types/submit
 */

/**
 * @type {string}
 */
export default 'submit'
